import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {PageComponent} from '../../page.component';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {ValidationService} from '../../services/validation.service';

@Component({
  selector: 'mp-change-password',
  templateUrl: 'change-password.component.html',
  styleUrls: ['change-password.component.css']
})
export class ChangePasswordComponent extends PageComponent implements OnInit {

  loginForm: FormGroup;
  passwordControlOld = new FormControl('', [Validators.required]);
  passwordControlNew1 = new FormControl('', [Validators.required]);
  passwordControlNew2 = new FormControl('', [Validators.required]);
  loading = false;

  errNotAuthorized: boolean;
  errFailure: boolean;
  errNotEqual: boolean;
  errWeak: boolean;

  constructor(private formBuilder: FormBuilder,
              private readonly apiService: ApiService,
              private readonly validationService: ValidationService,
              private router: Router) {
    super();
  }

  isLightPage(): boolean {
    return true;
  }

  canGoBack(): boolean {
    return true;
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      passwordOld: this.passwordControlOld,
      passwordNew1: this.passwordControlNew1,
      passwordNew2: this.passwordControlNew2
    });

    this.resetErrors();
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      return;
    }

    this.resetErrors();

    if (this.loginForm.controls.passwordNew1.value !== this.loginForm.controls.passwordNew2.value) {
      this.errNotEqual = true;
      return;
    }

    this.loading = true;

    const email = sessionStorage.getItem('user');
    const pwHashed = this.validationService.hashEmailAndPassword(email, this.loginForm.controls.passwordOld.value);

    this.apiService.changeUserPassword(email, pwHashed, this.loginForm.controls.passwordNew1.value)
      .subscribe(() => {
        this.loading = false;
        this.router.navigate(['login']);
      }, (err: HttpErrorResponse) => {
        this.loading = false;

        if (err.status === 401) {
          this.errNotAuthorized = true;
        } else if (err.status === 400) {
          this.errWeak = true;
        } else {
          this.errFailure = true;
        }

      });
  }

  private resetErrors(): void {
    this.errNotAuthorized = false;
    this.errFailure = false;
    this.errNotEqual = false;
    this.errWeak = false;
  }
}
